import { api } from '@marketplace-web/core-api/core-api-client-data'

import { ReportReasonCatalogSystem } from '../constants/report-reason'
import { GetIsAlertsGeneratorBusyResp } from '../types/admin-alerts'

export const generateAlertsFromSearchParams = ({
  searchParams,
  reportReason,
}: {
  searchParams: Record<string, string | Array<string> | undefined>
  reportReason: ReportReasonCatalogSystem | undefined
}) =>
  api.post('/admin/alert_generators/execute', {
    item_search_params: searchParams,
    report_reason_code: reportReason,
  })

export const generateAlertsFromFirstPage = ({
  itemIds,
  reportReason,
}: {
  itemIds: Array<number>
  reportReason: ReportReasonCatalogSystem | undefined
}) =>
  api.post('/admin/alert_generators/batch_execute', {
    item_ids: itemIds,
    report_reason_code: reportReason,
  })

export const checkIsAlertsGeneratorBusy = () =>
  api.get<GetIsAlertsGeneratorBusyResp>('/admin/alert_generators/is_busy')

export const checkIsAlertsGeneratorBatchBusy = () =>
  api.get<GetIsAlertsGeneratorBusyResp>('/admin/alert_generators/is_batch_busy')
